export enum Role {
  ADMIN = 'admin',
  CUSTOMER = 'customer',
}
